/** @jsxImportSource @emotion/react */
'use memo'

import type { Team } from '@sportninja/common/hooks/useUserRegistrationTeams'
import { useTeamHistory } from '../../hooks/useTeamHistory'
import TeamSummaryCard from './TeamSummaryCard'

interface Props {
  /** The chosen team, from the rep's own list; null when none is chosen. */
  team: Team | null
  /** The registration's sport — names the officials' roles. */
  sportId?: string | null
}

/**
 * The chosen team's summary card, or nothing when no team is chosen or its
 * payload carries no history to show.
 */
const SelectedTeamSummary = ({ team, sportId }: Props) => {
  const { buildHistory, copy } = useTeamHistory(sportId)
  const history = team ? buildHistory(team) : null

  if (!team || !history) {
    return null
  }
  return <TeamSummaryCard team={team} history={history} copy={copy} />
}

export default SelectedTeamSummary
